import axios from 'axios';
import { stagingServerUrl } from '../server/constants';

export const forgotPassword = (values: {email: string}) => {
  // TODO Forgot Password Link & Footer mismatch issue
  // const host = window.location.host || externalServerUrl;
  // const sign = 'Kai-Zen Agent Resources';
  // const payload = {email: values.email, host, sign};
  const payload = {...values};
  const url = `${stagingServerUrl}/account/forgot/password`;

  return axios.post(url, payload);
}
